import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { useDispatch, useSelector } from 'react-redux'

import IntlLink from '../components/IntlLink'
import SearchInput from './search/input'
import { setSearchValue } from '../state'
import { menus, logoLink } from '../../config'

const Navbar = () => {
  const { BrandSVG } = useStaticQuery(
    graphql`
      query {
        BrandSVG: file(relativePath: { eq: "dmhub-api-logo.svg" }) {
          publicURL
        }
      }
    `
  )

  const dispatch = useDispatch()

  const { docInfo, searchValue } = useSelector((state) => state)

  const [showBorder, setShowBorder] = useState(false)
  const [burgerActive, setBurgerActive] = useState(false)
  const handleSetBurgerActive = () => setBurgerActive(!burgerActive)

  const handleSetSearchValue = (value) => dispatch(setSearchValue(value))

  useEffect(() => {
    const scrollListener = () => {
      const winScrollTop = document.documentElement.scrollTop

      setShowBorder(winScrollTop > 0)
    }

    window.addEventListener('scroll', scrollListener)

    return () => window.removeEventListener('scroll', scrollListener)
  }, [])

  return (
    <nav
      className={`navbar is-fixed-top cl-Navbar${
        showBorder ? ' has-border-and-shadow' : ''
      }`}
      role="navigation"
    >
      <div className="container">
        <div className="navbar-brand" style={{ marginLeft: 0 }}>
          <div className="navbar-item with-brand">
            <span className="navbar-title">Convertlab | 荟聚</span>
          </div>

          <div className="navbar-item search-input-mobile">
            <SearchInput
              docInfo={docInfo}
              searchValue={searchValue}
              setSearchValue={handleSetSearchValue}
            />
          </div>

          <button
            className={`navbar-burger${burgerActive ? ' is-active' : ''}`}
            aria-label="menu"
            aria-expanded="false"
            onClick={handleSetBurgerActive}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div className={`navbar-menu${burgerActive ? ' is-active' : ''}`}>
          <div className="navbar-end">
            {menus.map(menu => (
              <IntlLink
                key={menu.link}
                to={menu.link}
                className="navbar-item with-main-section"
                type={menu.target}
              >
                {menu.title}
              </IntlLink>
            ))}
          </div>
        </div>
        <div className="navbar-item search-input-pc">
          <SearchInput
            docInfo={docInfo}
            searchValue={searchValue}
            setSearchValue={handleSetSearchValue}
          />
        </div>
      </div>
    </nav>
  )
}

export default Navbar
